// extracted by mini-css-extract-plugin
module.exports = {"flagWrapper":"flag-module--flagWrapper--1biaS","flag":"flag-module--flag--1JnKO","withoutContainer":"flag-module--withoutContainer--2aKG-","text":"flag-module--text--2YlrA"};